import React from 'react'
import ScrollProgressBar from '../components/General/ScrollProgressBar/ScrollProgressBarV1'
export default function ScrollProgressBarV1(props) {
  const {
    // configData,
    // businessData,
    // options,
    // gonationID,
    // locationIndex,
    // locations,
    // city,
    variantName,
  } = props

  const variant = variantName ? variantName : 'scrollBarProgressV1'

  return <ScrollProgressBar {...props} variantName={variant} />
}
